import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { BusinessUnitForm } from '@/components/forms/BusinessUnitForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateBusinessUnitPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create Business Unit</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a parent, child, or sub-child business unit for the selected client
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <BusinessUnitForm
              onSuccess={() => navigate('/organization/business-units')}
              onCancel={() => navigate('/organization/business-units')}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

